import { useQuery } from 'react-query';
import { QueryKeys, MONTH_FORMAT, TIME_FORMAT } from '../constants';
import { IGetTransaction, ITransaction } from '../types/IWallet';
import { getTransactions } from '../api/wallet';
import { useState } from 'react';
import format from 'date-fns/format';

interface ITransactionsByDate {
    date: string;
    values: ITransaction[];
}

interface IUseTransactionsResult {
    transactions: ITransactionsByDate[];
    isLoading: boolean;
}

export function useGetTransactions(params: IGetTransaction): IUseTransactionsResult {
    const [transactions, setTransactions] = useState<ITransactionsByDate[]>([]);

    const { isLoading } = useQuery(
        [QueryKeys.getTransactions, params.pageNumber, params.pageSize, params.userId],
        () => getTransactions(params),
        {
            onSuccess(res) {
                if (res && res.length > 0) {
                    const transactionsByDate: ITransactionsByDate[] = transactions ?? [];
                    res.forEach((transaction) => {
                        let transactionIdx = -1;
                        if (transactionsByDate.length > 0) {
                            transactionIdx = transactionsByDate.findIndex(
                                (tr) => tr.date === format(new Date(transaction.createdAt), MONTH_FORMAT)
                            );
                        }

                        if (transactionIdx === -1) {
                            transactionsByDate.push({
                                date: format(new Date(transaction.createdAt), MONTH_FORMAT),
                                values: [
                                    {
                                        ...transaction,
                                        time: format(new Date(transaction.createdAt), TIME_FORMAT),
                                    },
                                ],
                            });
                        } else {
                            transactionsByDate[transactionIdx] = {
                                ...transactionsByDate[transactionIdx],
                                values: transactionsByDate[transactionIdx].values.concat({
                                    ...transaction,
                                    time: format(new Date(transaction.createdAt), TIME_FORMAT),
                                }),
                            };
                        }
                    });
                    setTransactions(transactionsByDate);
                }
            },
        }
    );

    return { transactions, isLoading };
}
